import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video_2",
  "use": "icon-video_2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-video_2\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M18,17v2h2V17ZM4,17v2H6V17Zm14-4v2h2V13ZM4,13v2H6V13ZM18,9v2h2V9ZM4,9v2H6V9ZM18,5V7h2V5ZM4,5V7H6V5ZM8,5V19h8V5ZM2,4A1,1,0,0,1,3,3H21a1,1,0,0,1,1,1V20a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol